/**
 * The caller's in-app inbox — the bell. Always the signed-in person's own.
 */

import { api } from "@/api/client";

export interface InboxMessage {
  id: string;
  event: string;
  title: string;
  body: string;
  /** An in-app path to open, or "" for nowhere. */
  link: string;
  readAt: string | null;
  createdAt: string;
}

export interface Inbox {
  unread: number;
  messages: InboxMessage[];
}

interface Wire {
  unread: number;
  results: {
    id: string;
    event: string;
    title: string;
    body: string;
    link: string;
    read_at: string | null;
    created_at: string;
  }[];
}

export const inboxApi = {
  async get(): Promise<Inbox> {
    const body = await api.get<Wire>("/inbox/");
    return {
      unread: body.unread,
      messages: body.results.map((m) => ({
        id: m.id,
        event: m.event,
        title: m.title,
        body: m.body,
        link: m.link,
        readAt: m.read_at,
        createdAt: m.created_at,
      })),
    };
  },

  /** Mark these read — or every one of them, when `ids` is left out. */
  async markRead(ids?: string[]): Promise<void> {
    await api.post("/inbox/read/", ids ? { ids } : {});
  },
};
